<template>
  <div>
    <b-checkbox v-model="checked" @input="questionAnswered" :disabled="isDisabled || tab == -1" :class="{mandatory:isMandatory}">
      {{question}}
    </b-checkbox>
  </div>
</template>
<script>
export default {
  name: 'CheckboxQuestion',
  props: {
    question: String,
    isDisabled: Boolean,
    isMandatory: Boolean,
    existingValue: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    questionAnswered() {
      this.$emit('question-answered', this.checked);
    },
  },
  data() {
    return {
      checked: this.existingValue,
    };
  },
};
</script>
